import React, { forwardRef, useMemo } from 'react';
import { Input as InputBase, InputProps } from '@chakra-ui/core';

import { Container, Label, Error } from './styles';

interface Props extends InputProps {
  label?: string;
  error?: any;
  borderColor?: string;
  name: string;
}

const Input: React.FC<Props> = forwardRef(({ label, borderColor, name, error, ...props }, ref) => {
  const isError = useMemo(() => {
    return !!error && !!error[name];
  }, [error, name]);

  return (
    <Container>
      <Label color={isError ? '#f00' : '#01509C'}>{label}</Label>
      <InputBase
        {...props}
        name={name}
        ref={ref}
        color="#333 !important"
        borderColor={isError ? '#f00' : '#01509C'}
        borderRadius='6px'
        height='36px'
        fontSize={14}
      />
      {!!error && !!error[name] && <Error>{error[name].message ?? error[name]}</Error>}
    </Container>
  );
});

export default Input;
